export const fileToBase = (file: File): Promise<string> => {
  return new Promise<string>((resole, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resole(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};
